import React, { useCallback, useRef, forwardRef, useImperativeHandle, Ref } from "react";
import { GoogleReCaptcha, useGoogleReCaptcha } from "react-google-recaptcha-v3";

export interface ReCaptchaHandle {
  getRecaptchaToken: () => Promise<string | null>;
}

const ReCaptchaInput = forwardRef<ReCaptchaHandle>((_, ref: Ref<ReCaptchaHandle>) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const refreshRef = useRef(0);

  const getRecaptchaToken = useCallback(async () => {
    if (!executeRecaptcha) return null;
    refreshRef.current += 1;
    const token = await executeRecaptcha(`submit_form_${refreshRef.current}`);
    return token;
  }, [executeRecaptcha]);

  useImperativeHandle(ref, () => ({
    getRecaptchaToken,
  }));

  return <GoogleReCaptcha onVerify={() => {}} />;
});

ReCaptchaInput.displayName = "ReCaptchaInput";

export default React.memo(ReCaptchaInput);
